export const DEFAULT_LANGUAGE = 'en'

export const SUPPORTED_LANGUAGES = Object.freeze([
  {
    code: 'en',
    locale: 'en-US',
    name: 'English',
    nativeName: 'English',
    direction: 'ltr',
  },
  {
    code: 'es',
    locale: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    direction: 'ltr',
  },
])

const supportedCodes = new Set(SUPPORTED_LANGUAGES.map(({ code }) => code))

export const isSupportedLanguage = (value) => supportedCodes.has(value)

export const normalizeLanguage = (value) => {
  if (typeof value !== 'string') return null

  const code = value.trim().toLowerCase().replace('_', '-').split('-')[0]
  return isSupportedLanguage(code) ? code : null
}

export const getLanguageConfig = (value) =>
  SUPPORTED_LANGUAGES.find(({ code }) => code === normalizeLanguage(value)) ||
  SUPPORTED_LANGUAGES.find(({ code }) => code === DEFAULT_LANGUAGE)
